// Per-module read-only lock.
//
// `isReadOnly(user, moduleId)` in auth.ts has always known whether the signed-in
// user holds "Read Only" rather than "Full Access" on the open module, but
// nothing consumed it — so a read-only grant behaved exactly like full access.
// ModuleRoute now publishes that answer here, and the three shared controls that
// every module writes through read it:
//
//   FormLayout  -> hides the submit button (creates and edits)
//   Button      -> renders nothing when it writes: variant="danger" (deletes
//                  and voids), type="submit" (raw-form saves), or the `write`
//                  flag (a save that calls its handler directly). Reading
//                  controls (View, Print, Export, tabs) are untouched.
//   RowActions  -> items marked danger are dropped from the row menu
//
// That covers every module through the shared controls. A few modules used a
// raw <button style={styles.deleteBtn}>Void</button> that slipped past the
// Button guard; those were switched to <Button variant="danger"> so the rule
// reaches them too (CHM-071).
//
// IMPORTANT: this hides controls, it does not block requests. A read-only user
// can still call the API directly. The server has to enforce the same rule for
// this to be more than a UI courtesy.

import { createContext, useContext } from 'react';

/** True while the open module is read-only for the signed-in user. */
export const ReadOnlyContext = createContext<boolean>(false);

export const useReadOnly = (): boolean => useContext(ReadOnlyContext);

export default ReadOnlyContext;
